import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { UserManagementService, ChangePasswordRequest } from '../../services/user-management.service';

@Component({
  selector: 'app-change-password',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  passwordForm: ChangePasswordRequest = {
    current_password: '',
    new_password: '',
  };
  
  confirmPassword: string = '';
  loading = false;
  errorMessage = '';
  successMessage = '';
  showPassword = {
    current: false,
    new: false,
    confirm: false
  };

  constructor(
    private userService: UserManagementService,
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  onSubmit(): void {
    this.clearMessages();

    // Validation
    if (!this.passwordForm.current_password || !this.passwordForm.new_password || !this.confirmPassword) {
      this.errorMessage = 'All fields are required';
      return;
    }

    if (this.passwordForm.new_password !== this.confirmPassword) {
      this.errorMessage = 'New password and confirm password do not match';
      return;
    }

    if (this.passwordForm.new_password.length < 8) {
      this.errorMessage = 'Password must be at least 8 characters long';
      return;
    }

    if (!this.validatePasswordStrength(this.passwordForm.new_password)) {
      this.errorMessage = 'Password must contain at least one uppercase letter, one lowercase letter, and one digit';
      return;
    }

    if (this.passwordForm.current_password === this.passwordForm.new_password) {
      this.errorMessage = 'New password must be different from current password';
      return;
    }

    this.loading = true;
    this.userService.changePassword(this.passwordForm).subscribe({
      next: (response) => {
        this.successMessage = 'Password changed successfully! Redirecting to dashboard...';
        this.loading = false;
        setTimeout(() => {
          this.router.navigate(['/dashboard']);
        }, 2000);
      },
      error: (error) => {
        console.error('Error changing password:', error);
        this.errorMessage = error.error?.detail || 'Failed to change password. Please check your current password.';
        this.loading = false;
      }
    });
  }

  validatePasswordStrength(password: string): boolean {
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasDigit = /[0-9]/.test(password);
    return hasUpperCase && hasLowerCase && hasDigit;
  }

  togglePasswordVisibility(field: 'current' | 'new' | 'confirm'): void {
    this.showPassword[field] = !this.showPassword[field];
  }

  clearMessages(): void {
    this.errorMessage = '';
    this.successMessage = '';
  }

  cancel(): void {
    this.router.navigate(['/dashboard']);
  }
}
